<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 19v-1a11 11 0 00-6-9.8V7a1 1 0 00-1-1h-8a1 1 0 00-1 1v1.2A11 11 0 005 18v1a3 3 0 00-2 3 3.05 3.05 0 002.6 2.8 67.93 67.93 0 0010.4.7 67.93 67.93 0 0010.4-.75A3.05 3.05 0 0029 22a3 3 0 00-2-3zm-.92 3.82A66.33 66.33 0 0116 23.5a66.33 66.33 0 01-10.08-.72 1.07 1.07 0 01-.92-.93 1 1 0 01.81-1.05A1.47 1.47 0 007 19.34V18a9 9 0 014-7.47V15a1 1 0 002 0V8h6v7a1 1 0 002 0v-4.47A9 9 0 0125 18v1.34a1.47 1.47 0 001.19 1.46 1 1 0 01.81 1.05 1.07 1.07 0 01-.92.93z"/></svg>